import styled from 'styled-components'

import { Flex } from '@/@bothrs-ui/web/components/layout'
import { breakpoints } from '@/config/layout'

const LoginLayoutContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column-reverse;
  align-items: space-between;
  overflow: auto;

  height: 100vh;

  padding-top: var(--safe-area-inset-top);
  padding-bottom: calc(max(var(--safe-area-inset-bottom, 0px), 20px));

  @media ${breakpoints.fromS} {
    flex-direction: row;
    height: 100vh;
    max-height: 100vh;
  }
`

const LoginLayoutLogo = styled.div`
  position: absolute;
  top: 30px;
  left: 24px;
  max-height: 70px;

  @media ${breakpoints.fromS} {
    left: 100px;
  }
`

const LoginLayoutContent = styled.main`
  flex-shrink: 0;
  width: 100%;
  padding: 48px 24px 0 24px;
  padding-bottom: calc(
    max(var(--safe-area-inset-bottom, 0px), 20px) +
      ${({ theme }) => theme.UI.Spacing.Space1}
  );

  display: flex;
  align-items: center;

  @media ${breakpoints.fromS} {
    width: 60vw;
    max-width: 60vw;
    min-width: 60vw;
  }

  @media ${breakpoints.fromM} {
    align-items: center;
    width: 50vw;
    max-width: 50vw;
    min-width: 50vw;
  }
`

const LoginLayoutImageContainer = styled.div`
  position: relative;
  min-height: 200px;
  width: 100%;
  flex: 1;
  flex-shrink: 1;

  @media ${breakpoints.fromS} {
    height: 100vh;
  }
`

const LoginLayoutImage = styled.img<{ imagePosition?: string }>`
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: ${({ imagePosition }) => imagePosition ?? 'center'};
  border-radius: 0 0 80px 0;
  @media ${breakpoints.fromS} {
    border-radius: 0;
  }
`

const StLogosBanner = styled(Flex)`
  flex-shrink: 0;
  width: 100%;
  background: ${({ theme }) => theme.Colors.Background.White};
  height: auto;
  padding: ${({ theme }) => `${theme.UI.SpacingPx.Space5} ${theme.UI.SpacingPx.Space6}`};
`

const StLogo = styled.img`
  max-height: ${({ theme }) => theme.UI.Spacing.Space6 * 1.25}px;

  @media ${breakpoints.fromS} {
    height: ${({ theme }) => theme.UI.Spacing.Space10 * 1.25}px;
    max-height: none;
  }
`

export {
  LoginLayoutContainer,
  LoginLayoutContent,
  LoginLayoutImage,
  LoginLayoutImageContainer,
  LoginLayoutLogo,
  StLogo,
  StLogosBanner,
}
